import { FirstBasementLevelSpecification } from '../../BasementLevelSpecification';
import { LevelSpecification } from '../../LevelSpecification';

export const isFirstBasementLevel = (
  level: LevelSpecification
): level is FirstBasementLevelSpecification => level.level === -1;
